export const contentTableConfig = {
  title: '渠道列表',
  propList: [
    {prop: 'thirdParty',
      label: '所属第三方',
      minWidth: '80'
    },
    {prop: 'thirdPartyAlias',
      label: '所属第三方别名',
      minWidth: '80'
    },
    {
      prop: 'channelName',
      label: '渠道名称',
      minWidth: '80'
    },
    {
      prop: 'shortName',
      label: '渠道简称',
      minWidth: '80'
    },
    {
      prop: 'createdTime',
      label: '创建时间',
      minWidth: '100'
    },
    {
      label: '操作',
      minWidth: '60',
      slotName: 'handler'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
